import React from 'react';
import { Container, Col, Row, Button } from 'reactstrap';
import TextField from "material-ui/TextField";
import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";
import Dialog from 'material-ui/Dialog';
import '../../../assets/css/required.css'
import queryString from 'query-string';
import axios from 'axios';
import urlBase from '../../../url-base';
import Checkbox from 'material-ui/Checkbox';

function formatCurrency(value) {
  if (!value) return '0,00';
  var cleanValue = value.toString().replace(/\D/g, '');
  if (cleanValue === '') return '0,00';
  var intValue = parseInt(cleanValue, 10).toString();
  if (intValue.length === 1) return '0,0' + intValue;
  if (intValue.length === 2) return '0,' + intValue;
  var cents = intValue.substring(intValue.length - 2);
  var osInteiros = intValue.substring(0, intValue.length - 2);
  osInteiros = osInteiros.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  return osInteiros + ',' + cents;
}

class PlanRegistration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dias_carencia:[
        {key: "Sem carência", name: "Sem carência"},
        {key: "Atendimento imediato", name: "Atendimento imediato"},
        {key: "1 MINUTO", name: "1 MINUTO"},
        {key: "24 HORAS", name: "24 HORAS"},
        {key: "15 DIAS", name: "15 DIAS"},
        {key: "30 DIAS", name: "30 DIAS"},
        {key: "45 DIAS", name: "45 DIAS"},
        {key: "60 DIAS", name: "60 DIAS"},
        {key: "90 DIAS", name: "90 DIAS"},
        {key: "120 DIAS", name: "120 DIAS"},
        {key: "180 DIAS", name: "180 DIAS"},
      ],
      badge: '',
           
      defaultPriceGroup: {
        chave: '',
        uf: '',
        city: '',
        startDate: '',
        endDate: '',
        price: '0,00',
        promotionPrice: '0,00',
        quantity: '',
        categoryPrice: '',
        cityList: [],
      },
      defaultCarenciaGroup: {
        carenciaName: '',
        carenciaCard: '', 
        carenciaBoleto: '', 
        carenciaServer: '', 
      },
      id: '',
      name: '',
      tradeName: '',
      contractFile : '',
      stateList: [],
      codeS4: '',          // ✅ CORRIGIDO: Inicializado explicitamente para evitar 'uncontrolled input'
      
      publish: false,
      ticket: false,
      server: false,
      card: false,
      value: '0,00',
      value2: '0,00', value3: '0,00', value4: '0,00', 
      serverValue2: '0,00', serverValue3: '0,00', serverValue4: '0,00',
      ticketValue2: '0,00', ticketValue3: '0,00', ticketValue4: '0,00',
      
      type: 'NULL',        // ✅ CORRIGIDO: Alinhado com o valor do item padrão do select
      usersTable: false,     
      description:'',
      status: '',
      grupos: [],
      carencias: [],
      modalErrors: false
    }

    this.requiredFields = ['name', 'tradeName','codes4', 'value', 'status'];
    this.errorField = { grupos: [] };

    this.handleChange = this.handleChange.bind(this);
    this.handleCarenciaTextChange = this.handleCarenciaTextChange.bind(this);    
  }

  componentDidMount() {
    var params = queryString.parse(window.location.search);
    if(params) {
      if(params.edit) {
        axios.get(urlBase.loopBack + 'Plans/'+params.edit).then((data) => {
          const plan = data.data;
          
          this.setState({
            id: plan.id,
            name: plan.name || '',
            tradeName: plan.tradeName || '',
            description: plan.description || '',
            contractFile : plan.contractFile || '',
            status: plan.status || '',
            value: formatCurrency(plan.value || '0,00'),
            
            publish: plan.publish || false,
            ticket: plan.ticket || false,
            server: plan.server || false,
            card: plan.card || false,

            value2: formatCurrency(plan.familyTable ? plan.familyTable.value2 : '0,00'),
            value3: formatCurrency(plan.familyTable ? plan.familyTable.value3 : '0,00'),
            value4: formatCurrency(plan.familyTable ? plan.familyTable.value4 : '0,00'),            
            
            serverValue2: formatCurrency(plan.serverTable ? plan.serverTable.value2 : '0,00'),
            serverValue3: formatCurrency(plan.serverTable ? plan.serverTable.value3 : '0,00'),
            serverValue4: formatCurrency(plan.serverTable ? plan.serverTable.value4 : '0,00'),

            ticketValue2: formatCurrency(plan.ticketTable ? plan.ticketTable.value2 : '0,00'),
            ticketValue3: formatCurrency(plan.ticketTable ? plan.ticketTable.value3 : '0,00'),
            ticketValue4: formatCurrency(plan.ticketTable ? plan.ticketTable.value4 : '0,00'),

            codeS4: plan.codeS4 || '',
            type: plan.type || 'NULL',
            usersTable: plan.usersTable || false,
            badge: plan.badge || ''
          });

          if(!plan.priceGroups || !plan.priceGroups.length){
            this.handlerAppendPriceGroup();
          } else {
            plan.priceGroups.map((price) => {
              this.getCity(price.uf, (data) => {
                price.cityList = data;
                price.price = formatCurrency(price.price || '0,00');
                price.promotionPrice = formatCurrency(price.promotionPrice || '0,00');
                this.handlerAppendPriceGroup(price);
              });
            })
          }
        
          if(!plan.carenciaGroups || !plan.carenciaGroups.length){
            this.handlerAppendCarenciaGroup();
          } else {
            plan.carenciaGroups.map((carencia) => {
              this.handlerAppendCarenciaGroup({
                carenciaName: carencia.name,
                carenciaCard: carencia.card,
                carenciaBoleto: carencia.ticket,
                carenciaServer: carencia.server
              });
            })
          }

        });
      } else {
        this.handlerAppendCarenciaGroup();
        this.handlerAppendPriceGroup();
      }     
    } else {
      this.handlerAppendCarenciaGroup();
      this.handlerAppendPriceGroup();
    }
    axios.get(urlBase.loopBack + 'APIS4s/UFs').then((data)=>{
      this.setState({stateList: data.data});
    })
    .catch(function (erro) {
      console.log(erro);
    });    
  }

  getCity(uf=null, fnCalback=null) {
    uf = parseInt(uf);
    const url = urlBase.loopBack+'APIS4s/Municipios';
    let dataPost = { idUF: uf };
    axios.post(url, dataPost)
    .then((result) => {
      if (fnCalback != null) { fnCalback(result.data); }
    })
    .catch(function (erro) { alert(erro); });
  }

  handleChange(e, _name, event, index, _value) {
    var name = '';
    var value = '';

    if (typeof _name === 'string' && event !== undefined) {
      name = _name;
      value = _value;
    } 
    else if (e && e.target && e.target.name) {
      name = e.target.name;
      value = e.target.value;
    }

    if (!name) return;

    var camposMoeda = [
      'value', 'value2', 'value3', 'value4', 
      'serverValue2', 'serverValue3', 'serverValue4', 
      'ticketValue2', 'ticketValue3', 'ticketValue4',
      'price', 'promotionPrice'
    ];

    if (camposMoeda.indexOf(name) !== -1) {
      value = formatCurrency(value);
    }

    var camposTabela = ["uf", "city", "price", "promotionPrice", "categoryPrice", "quantity", "startDate", "endDate", "carenciaName", "carenciaCard", "carenciaBoleto", "carenciaServer"];
    
    if (camposTabela.indexOf(name) === -1) {
      var objUpdate = {};
      objUpdate[name] = value;
      this.setState(objUpdate);
      return;
    }

    if (["uf", "city", "price", "promotionPrice", "categoryPrice", "quantity", "startDate", "endDate"].indexOf(name) !== -1) {
      var inputsGrupos = [].concat(this.state.grupos);
      var targetElement = e && e.target ? e.target : {};
      var dataset = targetElement.dataset || {};
      var chaveGrupo = e.chave || dataset.id;
      
      var idxGrupo = -1;
      for (var i = 0; i < inputsGrupos.length; i++) {
        if (inputsGrupos[i].chave == chaveGrupo) {
          idxGrupo = i;
          break;
        }
      }
      
      if (idxGrupo !== -1) {
        inputsGrupos[idxGrupo][name] = value;
        
        if (name === 'uf') {
          var self = this;
          this.getCity(value, function(data) {
            inputsGrupos[idxGrupo].cityList = data;
            self.setState({ grupos: inputsGrupos });
          });
        } else {
          this.setState({ grupos: inputsGrupos });
        }
      }
    } 
    else if (["carenciaName", "carenciaCard", "carenciaBoleto", "carenciaServer"].indexOf(name) !== -1) {
      var inputsCarencias = [].concat(this.state.carencias);
      var targetElementCarencia = e && e.target ? e.target : {};
      var datasetCarencia = targetElementCarencia.dataset || {};
      var chaveCarencia = e ? (e.chave || datasetCarencia.id) : null;
      
      var idxCarencia = -1;
      for (var j = 0; j < inputsCarencias.length; j++) {
        if (inputsCarencias[j].chave == chaveCarencia) {
          idxCarencia = j;
          break;
        }
      }
      
      if (idxCarencia !== -1) {
        inputsCarencias[idxCarencia][name] = value;
        this.setState({ carencias: inputsCarencias });
      }
    }
  }

  handleCarenciaTextChange(index, value) {
    var listaCarencias = [].concat(this.state.carencias);
    if (listaCarencias[index]) {
      listaCarencias[index].carenciaName = value;
      this.setState({ carencias: listaCarencias });
    }
  }
  handleErrorClose() { this.setState({modalErrors: false}); }
  handleErrorOpen() { this.setState({modalErrors: true}); return false; }

  handlerAppendPriceGroup( data  = null) {
    var chave = Math.floor((Math.random() * 9999) +1);
    var newInput = {...this.state.defaultPriceGroup};
    newInput.chave = chave;
    newInput.stateList = this.state.stateList;
    if(data) { newInput = Object.assign(newInput, data); }
    this.setState(prevState => ({ grupos: prevState.grupos.concat([newInput]) }));
  }  

  handlerAppendCarenciaGroup(data = null) {
    var chave = Math.floor((Math.random() * 999999) + 1);
    var newInput = {
      carenciaName: '',
      carenciaCard: -1,   
      carenciaBoleto: -1, 
      carenciaServer: -1  
    };
    newInput.chave = chave;
    if (data) { 
      newInput = Object.assign(newInput, {
        carenciaName: data.carenciaName || '',
        carenciaCard: data.carenciaCard !== undefined ? data.carenciaCard : -1,
        carenciaBoleto: data.carenciaBoleto !== undefined ? data.carenciaBoleto : -1,
        carenciaServer: data.carenciaServer !== undefined ? data.carenciaServer : -1 
      }); 
    }
    this.setState(prevState => ({ carencias: prevState.carencias.concat([newInput]) }));
  }  

  handleDeletePriceGroup (obj) {
    let index = this.state.grupos.indexOf(obj);
    this.state.grupos.splice(index, 1);
    this.setState(() => ({ grupos:  this.state.grupos }));
  }

  handleDeleteCarenciaGroup (obj) {
    let index = this.state.carencias.indexOf(obj);
    this.state.carencias.splice(index, 1);
    this.setState(() => ({ carencias:  this.state.carencias }));
  }

  hanlderSubmit() {
    let dataPost = {
      "name": this.state.name,
      "tradeName": this.state.tradeName,
      "contractFile" : this.state.contractFile,
      "status": this.state.status,
      "codeS4": this.state.codeS4,
      "value": this.state.value,
      "usersTable": this.state.usersTable,
      "type": this.state.type,
      "publish": this.state.publish,
      "ticket": this.state.ticket,
      "server": this.state.server,
      "card" : this.state.card,
      "familyTable" : {
            "value2": this.state.value2,
            "value3": this.state.value3,
            "value4": this.state.value4                        
      },
      "serverTable" : {
            "value2": this.state.serverValue2,
            "value3": this.state.serverValue3,
            "value4": this.state.serverValue4                        
      },
      "ticketTable" : {
            "value2": this.state.ticketValue2,
            "value3": this.state.ticketValue3,
            "value4": this.state.ticketValue4                        
      },
      "priceGroups": [],
      "carenciaGroups": []
    };

    this.state.grupos.map((value) => {
      if(value.price && value.uf) {
        let price = {
            uf: value.uf,
            city: value.city,
            startDate: value.startDate,
            endDate: value.endDate,
            price: value.price,
            promotionPrice: value.promotionPrice,
            quantity: value.quantity,
            categoryPrice: value.categoryPrice,
        }
        dataPost.priceGroups.push(price)
      }
    });

    this.state.carencias.map((value) => {
      if(value.carenciaName && (value.carenciaBoleto !== '' || value.carenciaCard !== '' || value.carenciaServer !== '')) {
        let item = {
            name: value.carenciaName,
            card: value.carenciaCard,
            ticket: value.carenciaBoleto,
            server: value.carenciaServer 
        }
        dataPost.carenciaGroups.push(item);
      }
    });

    let requestAxios;
    let message = `Sucesso ao cadastrar o Plano`;
    if(this.state.id) {
      dataPost.id = this.state.id;
      message = `Sucesso ao editar o Plano`;
      requestAxios = axios.put(urlBase.loopBack + 'Plans', dataPost)
    } else {
      requestAxios =  axios.post(urlBase.loopBack + 'Plans', dataPost);
    }

    requestAxios.then(() => {
      alert(message);
      setTimeout(() => { window.location.href= urlBase.client +'panel/planlist'; }, 1000);
    }).catch((err) => {
      console.log(err);
      this.setState({modalErrors: true})
    });
  }

  confirmCheck(e, isInputChecked) { this.setState({ usersTable: isInputChecked }); }
  handlePublishCheck(e, isInputChecked) { this.setState({ publish: isInputChecked }); }
  handleServerCheck(e, isInputChecked) { this.setState({ server: isInputChecked }); }
  handleTicketCheck(e, isInputChecked) { this.setState({ ticket: isInputChecked }); }
  handleCardCheck(e, isInputChecked) { this.setState({ card: isInputChecked }); }


  render() {
    const cardStyle = {
      background: '#fff',
      borderRadius: '8px',
      padding: '25px',
      marginBottom: '30px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      border: '1px solid #e0e0e0'
    };

    return (
      <div style={{ padding: '20px', backgroundColor: '#f4f7f9' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <div>
            <h2 style={{ color: '#333', fontWeight: '600', margin: 0 }}>MANUTENÇÃO DE PLANOS</h2>
          </div>
          <span style={{ fontSize: '14px', color: '#888' }}>* Campos obrigatórios</span>
        </div>

        <Container className="form_container_panel2">
          
          {/* SEÇÃO 1: DADOS BÁSICOS */}
          <div style={cardStyle}>
            <div style={{ borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '10px' }}>
              <h4 style={{ color: '#0056b3', margin: 0 }}>DADOS DO PLANO</h4>
              <small style={{ color: '#777' }}>Informações fundamentais para identificação</small>
            </div>
            
            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
              <Checkbox 
                label="Disponível para Venda (Publicar Plano)" 
                checked={this.state.publish} 
                onCheck={this.handlePublishCheck.bind(this)}
                labelStyle={{ fontWeight: 'bold', color: this.state.publish ? '#28a745' : '#dc3545' }}
              />
            </div>
            <Row>
              <Col md="4">
                {/* ✅ CORRIGIDO: || '' para evitar valor undefined */}
                <TextField floatingLabelText="NOME DO PLANO *" name="name" fullWidth={true} value={this.state.name || ''} onChange={this.handleChange} />
              </Col>
              <Col md="4">
                {/* ✅ CORRIGIDO: || '' para evitar valor undefined */}
                <TextField floatingLabelText="NOME FANTASIA *" name="tradeName" fullWidth={true} value={this.state.tradeName || ''} onChange={this.handleChange} />
              </Col>
              <Col md="4">
                {/* ✅ CORRIGIDO: || '' para evitar valor undefined */}
                <TextField floatingLabelText="ARQUIVO DO CONTRATO *" name="contractFile" fullWidth={true} value={this.state.contractFile || ''} onChange={this.handleChange} />
              </Col>
            </Row>

            <Row style={{ marginTop: '15px' }}>
              <Col md="2">
                {/* ✅ CORRIGIDO: || '' para evitar valor undefined */}
                <TextField floatingLabelText="CÓDIGO S4 *" name="codeS4" fullWidth={true} value={this.state.codeS4 || ''} onChange={this.handleChange} />
              </Col>
              { false && (
                <Col md="2">
                  <TextField 
                    floatingLabelText="VALOR" 
                    fullWidth={true} 
                    name="value"
                    value={this.state.value || ''}
                    onChange={this.handleChange}
                  />
                </Col>
              )}
              <Col md="3">
                <SelectField floatingLabelText="TIPO *" fullWidth={true} value={this.state.type} onChange={this.handleChange.bind(this, null, 'type')}>
                  <MenuItem value={"NULL"} primaryText="Selecione..." />
                  <MenuItem value={"PF"} primaryText="Pessoa Física (PF)" />
                  <MenuItem value={"PJ"} primaryText="Pessoa Jurídica (PJ)" />
                  <MenuItem value={"SP"} primaryText="Servidor Público (SP)" />

                </SelectField>
              </Col>
              <Col md="3">
                <SelectField floatingLabelText="STATUS *" fullWidth={true} value={this.state.status} onChange={this.handleChange.bind(this, null, 'status')}>
                  <MenuItem value={"ATIVO"} primaryText="ATIVO" />
                  <MenuItem value={"INATIVO"} primaryText="INATIVO" />
                </SelectField>
              </Col>
              <Col md="2" style={{ display: 'flex', alignItems: 'center', paddingTop: '25px' }}>
                <Checkbox label="Uso em Planilha" checked={this.state.usersTable} onCheck={this.confirmCheck.bind(this)} />
              </Col>
            </Row>
          </div>

          {/* SEÇÃO 2: TABELA FAMILIAR */}
          <div style={cardStyle}>
            <div style={{ borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h4 style={{ color: '#e67e22', margin: 0 }}>VALORES DA TABELA CARTÃO</h4>
                <small style={{ color: '#777' }}>Ative o controle ao lado para liberar a edição desta tabela.</small>
              </div>
              <div style={{ width: '200px' }}>
                <Checkbox 
                  label="Utiliza Cartão" 
                  checked={this.state.card} 
                  onCheck={this.handleCardCheck.bind(this)} 
                />
              </div>
            </div>          
            <Row>
              {['value2', 'value3', 'value4'].map((val, idx) => (
                <Col key={val} md="4">
                  <TextField 
                    floatingLabelText={`Valor 0${idx + 1}`} 
                    fullWidth={true} 
                    name={val}
                    value={this.state[val] || ''} 
                    disabled={!this.state.card}
                    onChange={this.handleChange} 
                  />
                </Col>
              ))}
            </Row>
          </div>

          {/* SEÇÃO 3: TABELA SERVIDOR */}
          <div style={cardStyle}>
            <div style={{ borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h4 style={{ color: '#e67e22', margin: 0 }}>VALORES DA TABELA SERVIDOR</h4>
                <small style={{ color: '#777' }}>Ative o controle ao lado para liberar a edição desta tabela.</small>
              </div>
              <div style={{ width: '200px' }}>
                <Checkbox 
                  label="Utiliza Servidor" 
                  checked={this.state.server} 
                  onCheck={this.handleServerCheck.bind(this)} 
                />
              </div>
            </div>
            <Row>
              {['serverValue2', 'serverValue3', 'serverValue4'].map((val, idx) => (
                <Col key={val} md="4">
                  <TextField 
                    floatingLabelText={`Valor Servidor 0${idx + 1}`} 
                    fullWidth={true} 
                    name={val}
                    disabled={!this.state.server} 
                    value={this.state[val] || ''}
                    onChange={this.handleChange}
                  />
                </Col>
              ))}
            </Row>
          </div>

          {/* SEÇÃO 4: TABELA BOLETO */}
          <div style={cardStyle}>
            <div style={{ borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h4 style={{ color: '#9b59b6', margin: 0 }}>VALORES DA TABELA BOLETO</h4>
                <small style={{ color: '#777' }}>Ative o controle ao lado para liberar a edição desta tabela.</small>
              </div>
              <div style={{ width: '200px' }}>
                <Checkbox 
                  label="Utiliza Boleto" 
                  checked={this.state.ticket} 
                  onCheck={this.handleTicketCheck.bind(this)} 
                />
              </div>
            </div>
            <Row>
              {['ticketValue2', 'ticketValue3', 'ticketValue4'].map((val, idx) => (
                <Col key={val} md="4">
                  <TextField 
                    floatingLabelText={`Valor Boleto 0${idx + 1}`} 
                    fullWidth={true} 
                    name={val}
                    disabled={!this.state.ticket}
                    value={this.state[val] || ''}
                    onChange={this.handleChange}
                  />
                </Col>
              ))}
            </Row>
          </div>

          {/* CONFIGURAÇÃO DE CARÊNCIAS DO BANCO */}
          <div style={cardStyle}>
            <div style={{ borderBottom: '1px solid #eee', marginBottom: '20px', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h4 style={{ color: '#2ecc71', margin: 0 }}>CARÊNCIAS PERSONALIZADAS DO PLANO</h4>
                <small style={{ color: '#777' }}>Defina prazos específicos por grupo de procedimento para este plano.</small>
              </div>
              <Button onClick={() => this.handlerAppendCarenciaGroup()} color="primary" size="sm">
                + Adicionar Carência
              </Button>
            </div>

            {this.state.carencias.map((carencia, index) => {
              return (
                <Row key={carencia.chave || index} style={{ alignItems: 'center', marginBottom: '10px', backgroundColor: '#fafafa', padding: '10px', borderRadius: '4px' }}>
                  <Col md="3">
                    <TextField 
                      floatingLabelText="Grupo / Procedimento *" 
                      fullWidth={true}
                      name="carenciaName"
                      value={carencia.carenciaName || ''}
                      onChange={(e) => this.handleCarenciaTextChange(index, e.target.value)}
                    />
                  </Col>
                  
                  <Col md="3">
                    <SelectField 
                      floatingLabelText="Carência Cartão" 
                      fullWidth={true} 
                      value={carencia.carenciaCard} 
                      onChange={this.handleChange.bind(this, { chave: carencia.chave }, 'carenciaCard')}
                    >
                      {this.state.dias_carencia.map(d => (
                        <MenuItem key={d.key} value={d.key} primaryText={d.name} />
                      ))}
                    </SelectField>
                  </Col>

                  <Col md="2">
                    <SelectField 
                      floatingLabelText="Carência Boleto" 
                      fullWidth={true} 
                      value={carencia.carenciaBoleto} 
                      onChange={this.handleChange.bind(this, { chave: carencia.chave }, 'carenciaBoleto')}
                    >
                      {this.state.dias_carencia.map(d => (
                        <MenuItem key={d.key} value={d.key} primaryText={d.name} />
                      ))}
                    </SelectField>
                  </Col>

                  <Col md="2">
                    <SelectField 
                      floatingLabelText="Carência Servidor" 
                      fullWidth={true} 
                      value={carencia.carenciaServer} 
                      onChange={this.handleChange.bind(this, { chave: carencia.chave }, 'carenciaServer')}
                    >
                      {this.state.dias_carencia.map(d => (
                        <MenuItem key={d.key} value={d.key} primaryText={d.name} />
                      ))}
                    </SelectField>
                  </Col>

                  <Col md="2" style={{ textAlign: 'center', paddingTop: '20px' }}>
                    <Button color="danger" size="sm" onClick={() => this.handleDeleteCarenciaGroup(carencia)}>
                      Remover
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>

          {/* BOTÕES DE AÇÃO */}
          <Row>
            <Col xs="12" style={{ textAlign: 'right', marginTop: '10px', paddingBottom: '50px' }}>
              <Button onClick={() => window.location.href= urlBase.client +'panel/planlist'} style={{ marginRight: '15px', color: '#fff' }}>
                Cancelar
              </Button>
              <Button onClick={() => this.hanlderSubmit()}  style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px 30px' }}>
                SALVAR PLANO
              </Button>
            </Col>
          </Row>

        </Container>

        {/* Modal de Erro */}
        <Dialog modal={true} open={this.state.modalErrors}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <i className="fas fa-exclamation-triangle" style={{ fontSize: '40px', color: '#ff9800' }}></i>
            <h3 style={{ marginTop: '15px' }}>Atenção!</h3>
            <p>Verifique os campos obrigatórios marcados com asterisco (*).</p>
            <Button onClick={this.handleErrorClose.bind(this)} className="modal_button2">Entendi</Button>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default PlanRegistration;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/Plans/PlanRegistration.js
 **/